module.exports = __webpack_public_path__ + "static/img/logo-footer.fadfa7cd.png";